import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { FormsService } from '../../../shared/services/forms/forms.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-visit-modal',
  templateUrl: './visit-modal.component.html',
  styleUrls: []
})
export class VisitModalComponent implements AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  visitTime: any;
  visitDate: any;
  dateModel: any;
  today = moment().format('yyyy-MM-ddTHH:mm');
  visitForm: FormGroup;
  sending = false;
  leadId: any;
  canRemoveVisit: boolean;

  constructor(private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly formsService: FormsService) { }

  ngAfterViewInit(): void {
    this.modalsHandler.visitLeadModal.subscribe(data => {
      const visitDate = data.visitDate ? moment.unix(data.visitDate / 1000) : null;
      this.canRemoveVisit = visitDate ? visitDate.isAfter(moment()) : false;
      this.visitForm = this.formsService.initFormVisit(visitDate);
      this.today = moment().format('yyyy-MM-ddTHH:mm');
      this.leadId = data.leadId;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  setVisitDate(isDeleteVisit?: boolean): void {
    if (!this.visitForm.valid && !isDeleteVisit) {
      return;
    }
    const visitLeadInput = this.formsService.bindVisitForm(this.leadId, this.visitForm);
    this.formsService.sendVisitForm(visitLeadInput)
      .then(() => {
        this.sending = true;
        this.modalService.dismissAll();
        this.leadComuService.launchReloadMyLead(this.leadId);
        this.toasterService
          .showToast(
            'success',
            'toast.title.appointment_date_success',
            'toasts.messages.appointment_date_success'
          );
        this.sending = false;
      })
      .catch(error => {
        this.toasterService
          .showToast(
            'error',
            'toast.title.visit_date_error',
            error.message
          );
        this.sending = false;
      });
  }

  removeVisit(): void {
    this.visitForm.get('visitDate').setValue('');
    this.setVisitDate(true);
  }

}
